import { render, staticRenderFns } from "./VouchersView.vue?vue&type=template&id=082908fe&scoped=true"
import script from "./VouchersView.vue?vue&type=script&lang=js"
export * from "./VouchersView.vue?vue&type=script&lang=js"
import style0 from "./VouchersView.vue?vue&type=style&index=0&id=082908fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082908fe",
  null
  
)

export default component.exports